import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { ApiAccountDashboardAsset } from 'api/rtk-api'
import { AssetNameCell, ColDefWithLoading, CurrencyCell } from 'components/core-v2'
import { displayPercentage } from 'utilities/number'

const Last12MonthsCell = ({
  data: { performancePercentage12Months }
}: ICellRendererParams<ApiAccountDashboardAsset>) => (
  <span className={performancePercentage12Months >= 0 ? 'positive' : 'negative'}>
    {displayPercentage(performancePercentage12Months, 2)}
  </span>
)

const YTDCell = ({
  data: { performancePercentageYTD }
}: ICellRendererParams<ApiAccountDashboardAsset>) => (
  <span className={performancePercentageYTD >= 0 ? 'positive' : 'negative'}>
    {displayPercentage(performancePercentageYTD, 2)}
  </span>
)

export const COLUMN_DEFS: ColDefWithLoading[] = [
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 200,
    flex: 0.6,
    cellRenderer: AssetNameCell,
    cellStyle: { display: 'flex' },
    loadingCellWidth: 'xl'
  },
  {
    headerName: 'Last 12 months',
    field: 'performancePercentage12Months',
    minWidth: 140,
    flex: 0.1,
    cellRenderer: Last12MonthsCell,
    type: 'rightAligned'
  },
  {
    headerName: 'YTD',
    field: 'performancePercentageYTD',
    minWidth: 140,
    flex: 0.1,
    cellRenderer: YTDCell,
    type: 'rightAligned'
  },
  {
    headerName: 'Trades',
    field: 'numberOfActiveAccounts',
    minWidth: 140,
    flex: 0.1,
    type: 'rightAligned'
  },
  {
    headerName: 'Value',
    field: 'zarValue',
    minWidth: 140,
    flex: 0.1,
    type: 'rightAligned',
    sort: 'desc',
    sortable: true,
    cellRenderer: CurrencyCell({ fieldName: 'zarValue' })
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: false,
  unSortIcon: true
}
